import { render, staticRenderFns } from "./abacusSvg.vue?vue&type=template&id=4c7adacf"
import script from "./abacusSvg.vue?vue&type=script&lang=js"
export * from "./abacusSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports